export default "__VITE_ASSET__3394240a__"